import {CHANGE_NEXT_BOX_DATE} from './ChangeNextBoxDate';

export const Mutations = {CHANGE_NEXT_BOX_DATE};
